export default "__VITE_ASSET__f64f64f3__"